/**
 * /dashboard/hr/assets — Asset register (Phase 3c — 2026-06-01).
 *
 * Reads (list types + assets) are any tenant user behind the feature
 * gate; register + every transition (assign/return/retire/lost) and
 * asset-type CRUD are RBAC'd to company_admin / hr_manager server-side.
 * The register-asset button + per-row transition controls are shown
 * only to HR admins (UX gate; backend re-checks and enforces the state
 * machine atomically — a control whose move is illegal from the asset's
 * current state is never rendered).
 *
 * Migration note (2026-06-01, Next.js → Vite): port of
 * frontend/src/app/(dashboard)/dashboard/hr/assets/page.tsx + layout.tsx,
 * flattened into one route that uses HrModuleShell. Swaps:
 *   - "use client" dropped
 *   - The "Asset types" admin link (→ Settings catalog) is DROPPED per
 *     SOP §8.3 + the Phase 3c spec — catalog admin moves to Settings in
 *     Phase 3g. The register-asset CTA remains.
 */

import { createFileRoute } from "@tanstack/react-router";
import { HrFeatureGate } from "@/components/hr/hr-feature-gate";
import { HrModuleShell } from "@/components/shared/hr-module-shell";
import { AssetList } from "@/components/hr/asset-list";
import { AssetForm } from "@/components/hr/asset-form";
import { useHrRoles } from "@/components/hr/use-hr-roles";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/hr/assets")({
  component: HrAssetsRoute,
});

function HrAssetsRoute() {
  const { isHrAdmin } = useHrRoles();

  return (
    <HrModuleShell
      title="Asset register"
      description="Company assets and who currently holds them."
      actions={isHrAdmin ? <AssetForm /> : undefined}
    >
      <HrFeatureGate>
        <AssetList />
      </HrFeatureGate>
    </HrModuleShell>
  );
}
